import { render, staticRenderFns } from "./LightText.vue?vue&type=template&id=43d9fac0&scoped=true&"
import script from "./LightText.vue?vue&type=script&lang=js&"
export * from "./LightText.vue?vue&type=script&lang=js&"
import style0 from "./LightText.vue?vue&type=style&index=0&id=43d9fac0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d9fac0",
  null
  
)

export default component.exports